module.exports = __webpack_public_path__ + "static/media/bg_blur.ace9365c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_blur.jpg
// module id = 600
// module chunks = 0